import api from "@shop/frontend/web/js/api";
import { reactive, readonly } from "vue";

/**
 * Тип состояния мероприятия
 * @typedef {Object} EventsState
 * @property {Array} items
 * @property {boolean} showLoadMore
 * @property {boolean} loading
 * @property {boolean} loadingMore
 * @property {number} page
 */

export const blockingTypeEnum = {
	MATCH: 'match',
	SUBSCRIPTION: 'subscription',
	SERVICE_TAGLESS: 'service_tagless',
	PERFORMANCE: 'performance',
	SHOW: 'show',
  };

/** @type {EventsState} */
const eventsState = reactive({
	items: [],
	showLoadMore: false,
	loading: false,
	loadingMore: false,
	page: 0,
});
/** @type {EventsState} */
const subscriptionsState = reactive({
	items: [],
	showLoadMore: false,
	loading: false,
	loadingMore: false,
	page: 0,
});
/** @type {EventsState} */
const servicesState = reactive({
	items: [],
	showLoadMore: false,
	loading: false,
	loadingMore: false,
	page: 0,
});
/** @type {EventsState} */
const performancesState = reactive({
	items: [],
	showLoadMore: false,
	loading: false,
	loadingMore: false,
	page: 0,
});
/** @type {EventsState} */
const showState = reactive({
	items: [],
	showLoadMore: false,
	loading: false,
	loadingMore: false,
	page: 0,
});
const selectTypes = reactive({
	items: [],
});

const currentFilters = reactive({
	dateRange: '',
	nomTags: 0,
	objectTags: 0,
});


/**
 * @param {Object} [params]
 * @param {Object<string, any>} params.searchParams
 */
function searchItems(state, type, params = {}) {
	state.loading = true;
	state.items = [];
	api.poster
		.getPosterItems({
			blocking: blockingTypeEnum[type],
			params: params.searchParams,
		})
		.then(res => {
			state.items = res.items;
			state.showLoadMore = res.leftCount > 0;
		})
		.finally(() => (state.loading = false));
}

function loadMoreItems(state, type) {
	state.page++;
	state.loadingMore = true;
	api.poster
		.getPosterItems({
			blocking: blockingTypeEnum[type],
			pagination: {
				page: state.page,
			},
			params: {
				dateRange: currentFilters.dateRange || '',
				nomTags: currentFilters.nomTags || '',
				objectTags: currentFilters.objectTags || '',
			}
		})
		.then(res => {
			state.items = state.items.concat(res.items);
			state.showLoadMore = res.leftCount > 0;
		})
		.finally(() => (state.loadingMore = false));
}

function searchEvents(params = {}) {
	searchItems(eventsState, "MATCH", params);
}

function loadMoreEvents(params) {
	loadMoreItems(eventsState, "MATCH", params);
}

function searchSubscriptions(params = {}) {
	searchItems(subscriptionsState, "SUBSCRIPTION", params);
}

function loadMoreSubscriptions() {
	loadMoreItems(subscriptionsState, "SUBSCRIPTION");
}

function searchServices(params = {}) {
	searchItems(servicesState, "SERVICE_TAGLESS", params);
}

function loadMoreServices() {
	loadMoreItems(servicesState, "SERVICE_TAGLESS");
}

function searchPerformances(params = {}) {
	searchItems(performancesState, "PERFORMANCE", params);
}

function loadMorePerformances() {
	loadMoreItems(performancesState, "PERFORMANCE");
}

function searchShows(params = {}) {
	searchItems(showState, 'SHOW', params);
}

function loadMoreShows() {
	loadMoreItems(showState, 'SHOW');
}

function setSelectTypes(items) {
	selectTypes.items = items;
}

function resetAllPages() {
	eventsState.page = 0;
	subscriptionsState.page = 0;
	performancesState.page = 0;
}

function setCurrentFilters(searchParams) {
	currentFilters.dateRange = searchParams.dateRange;
	currentFilters.nomTags = searchParams.nomTags;
	currentFilters.objectTags = searchParams.objectTags;
}

export default function useSiteStore() {
	return {
		getEventsState: readonly(eventsState),
		searchEvents,
		loadMoreEvents,
		getSubscriptionsState: readonly(subscriptionsState),
		searchSubscriptions,
		loadMoreSubscriptions,
		getServicesState: readonly(servicesState),
		searchServices,
		loadMoreServices,
		getPerformancesState: readonly(performancesState),
		getShowsState: reactive(showState),
		searchPerformances,
		loadMorePerformances,
		searchShows,
		loadMoreShows,
		getSelectTypes: readonly(selectTypes),
		setSelectTypes,
		resetAllPages,
		setCurrentFilters
	};
}
